import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  ref: "modalContent",
  class: "ErrorModal"
}
const _hoisted_2 = { class: "ErrorDetails" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("p", null, [
      _createElementVNode("i", { class: "lnr-notification-circle ErrorModalIcon" })
    ], -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, [
        (_ctx.errorIsRelatedToRetrieveDashboards)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(" The dashboard data could not be retrieved at this time. ")
            ], 64 /* STABLE_FRAGMENT */))
          : (_ctx.errorIsRelatedToRetrieveJWT)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(" Something went wrong with the authentication process necessary for displaying dashboards. No token was retrieved. ")
              ], 64 /* STABLE_FRAGMENT */))
            : (_ctx.errorIsRelatedToRetrieveJWTInstanceId)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createTextVNode(" Something went wrong with the authentication process necessary for displaying dashboards. No instance ID found for retrieving the token. ")
                ], 64 /* STABLE_FRAGMENT */))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createTextVNode(" An unknown error occurred. ")
                ], 64 /* STABLE_FRAGMENT */)),
        _cache[0] || (_cache[0] = _createTextVNode(" Please close this modal to trigger an automatic page refresh. ", -1 /* CACHED */))
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("p", null, " If the problem persists, please contact us. ", -1 /* CACHED */))
    ])
  ], 512 /* NEED_PATCH */))
}